vcui.define('support/notification-2.0.0.min', ['jquery', 'vcui'], function ($, core) {
    var txtMasking;
    var pageData;
    var _readyForSale;
    var _soldOut;

    var notification = {
        init: function (data) {
            var self = this;

            self.$pdpInfo = $('div.pdp-info-area'); // PDP info
            _readyForSale = data.modelStatusCode === "READY_FOR_SALE" ? true : false;
            _soldOut = data.modelStatusCode === "SOLD_OUT" ? true : false;

            // PDP modal (팝업)
            if (_readyForSale) {
                self.$notificationPopup = $('#salesNotificationPopup');  // 판매 알림 신청 입력
                self.$notificationLoginPopup = $('#salesNotificationLoginPopup'); // 판매 알림 신청 로그인
                self.$notificationCompletePopup = $('#salesNotificationCompletePopup'); // 판매 알림 신청 완료
                self.$notificationErrorPopup = $('#salesNotificationErrorPopup'); // 판매 알림 신청 에러
                self.$notificationNeedInfoPopup = $('#salesNotificationNeedInfoPopup'); // 판매 알림 신청 휴대폰 등록 요청
            } else if (_soldOut) {
                self.$notificationPopup = $('#restockNotificationPopup');  // 재입고 알림 신청 입력
                self.$notificationLoginPopup = $('#pushApplyLoginPopup'); // 재입고 알림 신청 로그인
                //BTOCSITE-79230 Start
                self.$notificationCompletePopup = $('#pushApplyCompletePopup'); // 재입고 알림 신청 완료
                //BTOCSITE-79230 End
                self.$notificationErrorPopup = $('#pushApplyErrorPopup'); // 재입고 알림 신청 에러
                self.$notificationNeedInfoPopup = $('#restockNotificationNeedInfoPopup'); // 재입고 알림 신청 휴대폰 등록 요청
            } else {
                return; // 올바르지 않은 요청
            }
            self.notificationUrl = self.$notificationPopup.data('notificationUrl');

            vcui.require(['helper/textMasking'], function () {
                self.setting(data);

                self.bindEvent();
            });
        },
        setting: function (data) {
            var self = this;

            txtMasking = new vcui.helper.TextMasking();
            pageData = data;

            self.loginFlag = pageData.loginFlag == 'Y' ? true : false;
            self.notificationFlag = pageData.notificationFlag == 'Y' ? true : false;
            self.setNotification();
        },
        setNotification: function () {
            var self = this;

            if (self.loginFlag) {
                if (self.notificationFlag) {
                    if (_readyForSale) {
                        self.$pdpInfo.find('.purchase-button.pre-order .notice').prop('disabled', true).addClass('disabled').find('span').text('판매 예정 (알림신청 완료)');
                    } else if (_soldOut) {
                        self.$pdpInfo.find('.purchase-button.pre-order .sold').prop('disabled', true).addClass('disabled').find('span').text('일시품절 (알림신청 완료)');
                    }
                } else {
                    self.$notificationPopup.find('.push-apply-info').find('dd:eq(0)').html(txtMasking.name(pageData.name));
                    self.$notificationPopup.find('.push-apply-info').find('dd:eq(1)').html(txtMasking.phone(pageData.mobileNo));
                }
            }
        },
        notificationPush: function () {
            var self = this;
            var param = {
                unifyId: pageData.unifyId,
                bizType: pageData.bizType,
                modelId: pageData.modelId,
                modelStatusCode: pageData.modelStatusCode,
                reqQty: 1,
                name: pageData.name,
                mobileNo: pageData.mobileNo
            };

            lgkorUI.showLoading();
            lgkorUI.requestAjaxData(self.notificationUrl, param, function (result) {
                lgkorUI.hideLoading();

                var data = result.data;
                //BTOCSITE-79230 Start
                // self.$notificationPopup.vcModal('hide');
                //BTOCSITE-79230 End

                if (data.success == 'Y') {
                    self.completeNotification(data);
                } else {
                    self.$notificationErrorPopup.vcModal();
                }
            });
        },
        completeNotification: function (data) {
            var self = this;
            var $number = self.$notificationCompletePopup.find('.number'),
                $product = self.$notificationCompletePopup.find('.product');
            //BTOCSITE-79230 Start
            $number.html(txtMasking.phone(pageData.mobileNo));
            $product.html(pageData.modelDisplayName);
            //BTOCSITE-79230 End

            if (_readyForSale) {
                self.$pdpInfo.find('.purchase-button.pre-order .notice').prop('disabled', true).addClass('disabled').find('span').text('판매 예정 (알림신청 완료)');
            } else if (_soldOut) {
                self.$pdpInfo.find('.purchase-button.pre-order .sold').prop('disabled', true).addClass('disabled').find('span').text('일시품절 (알림신청 완료)');
            }

            self.$notificationCompletePopup.vcModal();
        },
        notificationNeedInfoModify: function () {
            document.memberInfoModifyForm.unifyId.value = digitalData.userInfo.unifyId;
            document.memberInfoModifyForm.state.value = location.pathname + location.search;
            document.memberInfoModifyForm.submit();
        },
        bindEvent: function () {
            var self = this;

            self.$pdpInfo.find('div.purchase-button.pre-order .notice, div.purchase-button.pre-order .sold').on('click', function () {
                // 로그인 했을 경우, 핸드폰 번호가 없다면 휴대폰번호 등록하기 팝업으로 가야한다.
                if(self.loginFlag) {
                    if(commonData.hasOwnProperty("userInfo") && commonData.userInfo.cphn != null && commonData.userInfo.cphn != "") { // BTOCSITE-84481 [상품셀영향도] 디지털 데이터 수정 건
                        //BTOCSITE-79230 Start
                        // self.$notificationPopup.vcModal();
                        self.notificationPush();
                        //BTOCSITE-79230 End
                    } else {
                        self.$notificationNeedInfoPopup.vcModal();
                    }
                } else {
                    self.$notificationLoginPopup.vcModal();
                }
            });

            self.$notificationCompletePopup.on('modalhide', function () {
                self.$notificationCompletePopup.find('.number').html('');
                self.$notificationCompletePopup.find('.product').html('');
            });
            //BTOCSITE-79230 Start
            // self.$notificationPopup.on('click', '.btn-group .btn', function () {
            //     self.notificationPush();
            // });
            //BTOCSITE-79230 End
            self.$notificationNeedInfoPopup.on('click', '.btn-group .btn', function () {
                self.notificationNeedInfoModify();
            });
        }
    }
    return notification;
});